(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-gift]').forEach(function (gift) {
      var check = gift.querySelector('[data-gift-check]');
      var form = gift.closest('form');
      if (!check || !form) return;
      // Unticked: send blank values so any saved recipient/message is removed from the cart.
      form.addEventListener('submit', function () {
        if (check.checked) return;
        gift.querySelectorAll('[data-gift-field]').forEach(function (field) { field.value = ''; });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var menu = document.querySelector('[data-menu]');
    var openers = document.querySelectorAll('[data-menu-open]');
    function setMenu(open) {
      if (!menu) return;
      menu.hidden = !open;
      document.documentElement.style.overflow = open ? 'hidden' : '';
      openers.forEach(function (b) { b.setAttribute('aria-expanded', String(open)); });
      if (open) {
        var close = menu.querySelector('[data-menu-close]');
        if (close) close.focus();
      }
    }
    openers.forEach(function (b) { b.addEventListener('click', function () { setMenu(true); }); });
    document.querySelectorAll('[data-menu-close]').forEach(function (b) {
      b.addEventListener('click', function () { setMenu(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu && !menu.hidden) setMenu(false);
    });
    // Product cards in the drawer: reveal the second image while touched
    if (menu) {
      var touched = null;
      menu.addEventListener('touchstart', function (e) {
        var card = e.target.closest('.mie-menu__product');
        if (!card) return;
        touched = card;
        card.classList.add('is-touched');
      }, { passive: true });
      ['touchend', 'touchcancel'].forEach(function (type) {
        menu.addEventListener(type, function () {
          if (touched) { touched.classList.remove('is-touched'); touched = null; }
        }, { passive: true });
      });
    }

    document.querySelectorAll('[data-loc-select]').forEach(function (select) {
      select.addEventListener('change', function () { select.form.submit(); });
    });

    // Country/currency dropdown
    document.querySelectorAll('[data-loc-toggle]').forEach(function (t) {
      var list = t.parentElement.querySelector('[data-loc-list]');
      t.addEventListener('click', function () {
        var open = !list.hidden;
        list.hidden = open;
        t.setAttribute('aria-expanded', String(!open));
      });
      document.addEventListener('click', function (e) {
        if (!t.parentElement.contains(e.target)) { list.hidden = true; t.setAttribute('aria-expanded', 'false'); }
      });
    });
  })();

  // Shared scroll-reveal
  (function () {
    var els = document.querySelectorAll('.fade-up');
    if (!els.length || !('IntersectionObserver' in window)) { els.forEach(function (el){ el.classList.add('is-visible'); }); return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { obs.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mie-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.mie-annc[data-hours]').forEach(function (bar) {
    var timer = bar.querySelector('.mie-annc__timer');
    if (!timer) return;
    var hEl = timer.querySelector('[data-h]');
    var mEl = timer.querySelector('[data-m]');
    var sEl = timer.querySelector('[data-s]');
    var hours = parseFloat(bar.getAttribute('data-hours')) || 3;
    var key = 'mieAnnc:' + bar.id;
    var end = parseInt(sessionStorage.getItem(key), 10);
    if (!end || end < Date.now()) {
      end = Date.now() + hours * 3600 * 1000;
      sessionStorage.setItem(key, end);
    }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var diff = Math.max(0, end - Date.now());
      var s = Math.floor(diff / 1000);
      hEl.textContent = pad(Math.floor(s / 3600));
      mEl.textContent = pad(Math.floor((s % 3600) / 60));
      sEl.textContent = pad(s % 60);
      if (diff <= 0) { end = Date.now() + hours * 3600 * 1000; sessionStorage.setItem(key, end); }
    }
    tick();
    setInterval(tick, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mie-product-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mie-product-slider')) {
    customElements.define('mie-product-slider', class extends HTMLElement {
      connectedCallback() {
        const section = this.closest('.mie-pslider');
        this.prev = section.querySelector('[data-slider-prev]');
        this.next = section.querySelector('[data-slider-next]');
        this.prev.addEventListener('click', () => this.page(-1));
        this.next.addEventListener('click', () => this.page(1));
        this.addEventListener('scroll', () => this.sync(), { passive: true });
        window.addEventListener('resize', () => this.sync());
        this.sync();
      }

      page(direction) {
        this.scrollBy({ left: direction * this.clientWidth * 0.9, behavior: 'smooth' });
      }

      sync() {
        const max = this.scrollWidth - this.clientWidth - 2;
        this.prev.disabled = this.scrollLeft <= 2;
        this.next.disabled = this.scrollLeft >= max;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mie-product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mie-product-tabs')) {
    customElements.define('mie-product-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i));
          tab.addEventListener('keydown', (e) => {
            if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
            const next = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
            this.select(next);
            this.tabs[next].focus();
          });
        });
        this.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-tab-add]');
          if (!btn) return;
          const item = { id: btn.getAttribute('data-tab-add'), quantity: 1 };
          const plan = btn.getAttribute('data-selling-plan');
          if (plan) item.selling_plan = plan;
          if (typeof window.mieCartAddItems === 'function') {
            window.mieCartAddItems([item]);
            return;
          }
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [item] })
          }).then(() => { window.location.href = '/cart'; });
        });
      }

      select(index) {
        this.tabs.forEach((tab, i) => {
          const on = i === index;
          tab.setAttribute('aria-selected', String(on));
          tab.tabIndex = on ? 0 : -1;
          this.querySelector('#' + tab.getAttribute('aria-controls')).hidden = !on;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mie-promo-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (e) => {
    const link = e.target.closest('.mie-promo__btn[data-scroll-next]');
    if (!link) return;
    const next = link.closest('.shopify-section')?.nextElementSibling;
    if (!next) return;
    e.preventDefault();
    next.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  });

  if (!customElements.get('mie-countdown')) {
    customElements.define('mie-countdown', class extends HTMLElement {
      connectedCallback() {
        this.endsAt = Number(this.dataset.endsAt) * 1000;
        if (!this.endsAt) return;
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      tick() {
        const left = Math.floor((this.endsAt - Date.now()) / 1000);
        if (left <= 0) { this.hidden = true; clearInterval(this.timer); return; }
        const days = Math.floor(left / 86400);
        const hours = Math.floor((left % 86400) / 3600);
        const pad = (n) => String(n).padStart(2, '0');
        this.querySelector('[data-days]').textContent = pad(days);
        this.querySelector('[data-hours]').textContent = pad(hours);
        this.querySelector('[data-minutes]').textContent = pad(Math.floor((left % 3600) / 60));
        this.querySelector('[data-seconds]').textContent = pad(left % 60);
        // Drop the leading units once they reach zero (e.g. "18 : 47" in the final hour).
        this.querySelectorAll('[data-unit="days"]').forEach((el) => { el.hidden = days === 0; });
        this.querySelectorAll('[data-unit="hours"]').forEach((el) => { el.hidden = days === 0 && hours === 0; });
        this.hidden = false;
      }
    });
  }

  if (!customElements.get('mie-marquee')) {
    customElements.define('mie-marquee', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-marquee-track]');
        this.set = this.querySelector('[data-marquee-set]');
        if (!this.track || !this.set) return;
        this.speed = Math.max(Number(this.dataset.speed) || 40, 5); // px per second
        this.build = this.build.bind(this);

        // Measure once logos have their real widths, and again if the size changes.
        const imgs = Array.from(this.set.querySelectorAll('img'));
        Promise.all(imgs.map((img) => img.complete ? null : new Promise((r) => { img.addEventListener('load', r, { once: true }); img.addEventListener('error', r, { once: true }); })))
          .then(this.build);
        this.observer = new ResizeObserver(() => {
          clearTimeout(this.resizeTimer);
          this.resizeTimer = setTimeout(this.build, 150);
        });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      build() {
        // Remove old clones, measure one set, then clone until the track covers the screen twice over.
        this.track.querySelectorAll('[data-marquee-clone]').forEach((el) => el.remove());
        const setWidth = this.set.getBoundingClientRect().width;
        if (!setWidth) return;
        const copies = Math.ceil(this.clientWidth / setWidth) + 1;
        for (let i = 0; i < copies; i++) {
          const clone = this.set.cloneNode(true);
          clone.setAttribute('data-marquee-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
          this.track.appendChild(clone);
        }
        this.track.style.setProperty('--marquee-distance', setWidth + 'px');
        this.track.style.setProperty('--marquee-duration', (setWidth / this.speed) + 's');
        this.classList.add('is-ready');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mie-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.mie-reviews').forEach(function (root) {
    var track = root.querySelector('[data-review-track]');
    if (!track) return;
    var card = track.querySelector('.mie-review');
    var step = card ? card.offsetWidth + 20 : 360;
    var prev = root.querySelector('[data-review-prev]');
    var next = root.querySelector('[data-review-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step, behavior: 'smooth' }); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mie-trial-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var modal = document.querySelector('[data-trial-modal]');
    var toneWrap = modal && modal.querySelector('[data-trial-tone]');
    var claimBtn = modal && modal.querySelector('[data-trial-claim]');
    var upgradeBtn = modal && modal.querySelector('[data-trial-upgrade]');
    var upgradePriceEl = upgradeBtn && upgradeBtn.querySelector('[data-upgrade-price]');
    var clearCart = modal && modal.getAttribute('data-clear-cart') === '1';
    var current = { claimV: '', claimP: '', upV: '', upP: '', upPrice: '' };
    var selectedTone = '';

    // Purchase buttons stay locked until the shopper picks a skin tone.
    function setPurchaseEnabled(on) {
      [claimBtn, upgradeBtn].forEach(function (b) {
        if (!b) return;
        b.classList.toggle('is-locked', !on);
        b.setAttribute('aria-disabled', on ? 'false' : 'true');
      });
    }
    // Report the chosen tone to PostHog on the buy click (best-effort).
    function sendTone(tone, type) {
      try {
        if (window.posthog && typeof window.posthog.capture === 'function') {
          window.posthog.capture('trial_purchase_started', { skin_tone: tone, purchase_type: type });
        }
      } catch (e) {}
    }

    // Native (un-patched) fetch: subscription apps patch window.fetch and would strip the
    // selling_plan, so pull a native fetch from a hidden same-origin iframe to bypass that.
    var _nf;
    function nativeFetch() {
      if (_nf) return _nf;
      try {
        var ifr = document.createElement('iframe');
        ifr.setAttribute('aria-hidden', 'true'); ifr.style.display = 'none';
        (document.body || document.documentElement).appendChild(ifr);
        var f = ifr.contentWindow && ifr.contentWindow.fetch;
        if (f && ('' + f).indexOf('native code') !== -1) { _nf = f.bind(ifr.contentWindow); return _nf; }
      } catch (e) {}
      _nf = window.fetch.bind(window); return _nf;
    }

    // Add the variant (with its subscription selling plan) and go straight to checkout.
    var checkoutBusy = false;
    function goToCheckout(variantId, planId) {
      if (!variantId || checkoutBusy) return false;
      checkoutBusy = true;
      var nf = nativeFetch();
      var item = { id: parseInt(variantId, 10), quantity: 1 };
      if (planId) { item.selling_plan = parseInt(planId, 10) || planId; }
      var chain = clearCart ? nf('/cart/clear.js', { method: 'POST' }) : Promise.resolve();
      chain.then(function () {
        return nf((window.location.origin || '') + '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [item] }) });
      }).then(function () { window.location.href = '/checkout'; }, function () { window.location.href = '/checkout'; });
      return true;
    }

    function openModal(trigger) {
      if (!modal) return;
      var variant = (trigger && trigger.getAttribute('data-trial-variant')) || 'hero';
      current.claimV = trigger ? (trigger.getAttribute('data-claim-variant') || '') : '';
      current.claimP = trigger ? (trigger.getAttribute('data-claim-plan') || '') : '';
      current.upV = trigger ? (trigger.getAttribute('data-upgrade-variant') || '') : '';
      current.upP = trigger ? (trigger.getAttribute('data-upgrade-plan') || '') : '';
      current.upPrice = trigger ? (trigger.getAttribute('data-upgrade-price') || '') : '';
      if (upgradePriceEl) upgradePriceEl.textContent = current.upPrice ? (' – ' + current.upPrice) : '';
      // Featured-product hero: claim the currently-selected variant pill.
      if (trigger && trigger.getAttribute('data-claim-from-selection') === '1') {
        var thero = trigger.closest('[data-thero]');
        var sel = thero && thero.querySelector('[data-thero-variant]:checked');
        current.claimV = sel ? (sel.getAttribute('data-variant-id') || '') : '';
      }
      if (toneWrap) toneWrap.hidden = false;               // skin tone shows on both modals
      if (upgradeBtn) upgradeBtn.hidden = !current.upV;      // "purchase full item" shows when configured
      // Reset the tone choice each open; the buy buttons stay locked until one is picked.
      selectedTone = '';
      modal.querySelectorAll('[data-tone-opt]').forEach(function (t) { t.checked = false; });
      modal.querySelectorAll('.mie-ttone').forEach(function (l) { l.classList.remove('is-active'); });
      setPurchaseEnabled(false);
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }
    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    }
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-trial-open]');
      if (opener) { e.preventDefault(); openModal(opener); return; }
      if (e.target.closest('[data-trial-close]')) { closeModal(); return; }
      // Claim / Upgrade -> send the tone to PostHog, then add the variant + plan and jump to
      // checkout. Both are gated on a tone being chosen (button is visually locked until then).
      // If no variant is configured, the link's href (a placeholder) is followed instead.
      if (e.target.closest('[data-trial-claim]')) {
        if (!selectedTone) { e.preventDefault(); return; }
        sendTone(selectedTone, 'trial');
        if (current.claimV) { e.preventDefault(); goToCheckout(current.claimV, current.claimP); }
        return;
      }
      if (e.target.closest('[data-trial-upgrade]')) {
        if (!selectedTone) { e.preventDefault(); return; }
        sendTone(selectedTone, 'full_size');
        if (current.upV) { e.preventDefault(); goToCheckout(current.upV, current.upP); }
        return;
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && !modal.hidden) closeModal(); });

    // Skin-tone selection: highlight + record the choice + unlock the buy buttons.
    if (modal) {
      modal.querySelectorAll('[data-tone-opt]').forEach(function (t) {
        t.addEventListener('change', function () {
          modal.querySelectorAll('.mie-ttone').forEach(function (l) { l.classList.toggle('is-active', l.contains(t) && t.checked); });
          if (t.checked) { selectedTone = t.getAttribute('data-tone-label') || 'unknown'; setPurchaseEnabled(true); }
        });
      });
    }

    // Hero purchase-option radios: highlight + reflect price on the Get started button
    document.querySelectorAll('[data-thero]').forEach(function (thero) {
      var priceEl = thero.querySelector('[data-thero-cta-price]');
      var ctaBtn = thero.querySelector('.mie-thero__cta');
      var labelEl = thero.querySelector('[data-thero-cta-label]');
      var opts = Array.prototype.slice.call(thero.querySelectorAll('[data-thero-opt]'));
      var pills = Array.prototype.slice.call(thero.querySelectorAll('[data-thero-variant]'));
      function priceHtml(compare, price) {
        var h = '';
        if (compare) h += '<s>' + compare + '</s> ';
        if (price) h += '<b>' + price + '</b>';
        return h;
      }
      // Free-trial option -> "Claim your offer" (no price). Otherwise the default label +
      // the selected scent's price (full-size price for the upgrade card, one-time otherwise).
      function updateCta() {
        var v = thero.querySelector('[data-thero-variant]:checked');
        var o = thero.querySelector('[data-thero-opt]:checked');
        var isClaim = o && o.getAttribute('data-offer-label');
        var isUpgrade = o && o.getAttribute('data-opt-role') === 'upgrade';
        if (labelEl && ctaBtn) {
          labelEl.textContent = isClaim ? (ctaBtn.getAttribute('data-claim-label') || '') : (ctaBtn.getAttribute('data-default-label') || '');
        }
        if (priceEl) {
          var p = '';
          if (isClaim) { p = ''; }
          else if (isUpgrade && v && v.getAttribute('data-full-price')) { p = v.getAttribute('data-full-price'); }
          else if (v && v.getAttribute('data-cta-price')) { p = v.getAttribute('data-cta-price'); }
          else if (o) { p = o.getAttribute('data-cta-price') || ''; }
          priceEl.textContent = p ? (' – ' + p) : '';
        }
      }
      // Reflect the selected scent onto the cards + the modal's full-size target.
      function applySelection() {
        var sel = thero.querySelector('[data-thero-variant]:checked');
        var claimP = sel ? sel.getAttribute('data-claim-price') : '';
        var claimC = sel ? sel.getAttribute('data-claim-compare') : '';
        var fullVar = sel ? sel.getAttribute('data-full-variant') : '';
        var fullPlan = sel ? sel.getAttribute('data-full-plan') : '';
        var fullP = sel ? sel.getAttribute('data-full-price') : '';
        var fullC = sel ? sel.getAttribute('data-full-compare') : '';
        if (ctaBtn) {
          ctaBtn.setAttribute('data-upgrade-variant', fullVar || '');
          ctaBtn.setAttribute('data-upgrade-plan', fullPlan || '');
          ctaBtn.setAttribute('data-upgrade-price', fullP || '');
        }
        opts.forEach(function (o) {
          var role = o.getAttribute('data-opt-role');
          var card = o.closest('.mie-topt');
          if (!card) return;
          var pEl = card.querySelector('[data-opt-price]');
          if (role === 'upgrade') {
            var hasFull = !!fullVar;
            card.hidden = !hasFull;
            o.disabled = !hasFull;
            if (hasFull && pEl) pEl.innerHTML = priceHtml(fullC, fullP);
            if (!hasFull && o.checked) {
              var claimOpt = thero.querySelector('[data-thero-opt][data-offer-label]') || opts[0];
              if (claimOpt && claimOpt !== o) claimOpt.checked = true;
            }
          } else if (pEl) {
            pEl.innerHTML = priceHtml(claimC, claimP);
          }
        });
      }
      function syncOpts() { opts.forEach(function (o) { var l = o.closest('.mie-topt'); if (l) l.classList.toggle('is-active', o.checked); }); updateCta(); }
      function syncPills() {
        pills.forEach(function (o) { var l = o.closest('label'); if (l) l.classList.toggle('is-active', o.checked); });
        // The main product image stays fixed regardless of the selected scent.
        applySelection();
        syncOpts();
      }
      opts.forEach(function (o) { o.addEventListener('change', syncOpts); });
      pills.forEach(function (o) { o.addEventListener('change', syncPills); });
      syncPills();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mie-trial-how"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-hslider]').forEach(function (root) {
      var track = root.querySelector('[data-slider-track]');
      var dots = root.querySelector('[data-slider-dots]');
      if (!track || !dots) return;
      var slides = Array.prototype.slice.call(track.children);
      if (slides.length < 2) return;
      dots.innerHTML = slides.map(function (_, i) { return '<button type="button" aria-label="Go to ' + (i + 1) + '"' + (i === 0 ? ' class="is-active"' : '') + '></button>'; }).join('');
      var dotBtns = Array.prototype.slice.call(dots.children);
      dotBtns.forEach(function (b, i) { b.addEventListener('click', function () { slides[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); }); });
      var raf;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var mid = track.scrollLeft + track.clientWidth / 2;
          var best = 0, bestDist = Infinity;
          slides.forEach(function (s, i) { var c = s.offsetLeft + s.offsetWidth / 2; var d = Math.abs(c - mid); if (d < bestDist) { bestDist = d; best = i; } });
          dotBtns.forEach(function (b, i) { b.classList.toggle('is-active', i === best); });
        });
      }, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mie-trial-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.mie-trev[data-hslider]').forEach(function (root) {
      var track = root.querySelector('[data-slider-track]');
      var dots = root.querySelector('[data-slider-dots]');
      if (!track || !dots) return;
      var slides = Array.prototype.slice.call(track.children);
      if (slides.length < 2) { dots.style.display = 'none'; return; }
      dots.innerHTML = slides.map(function (_, i) { return '<button type="button" aria-label="Go to ' + (i + 1) + '"' + (i === 0 ? ' class="is-active"' : '') + '></button>'; }).join('');
      var dotBtns = Array.prototype.slice.call(dots.children);
      dotBtns.forEach(function (b, i) { b.addEventListener('click', function () { slides[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' }); }); });
      var raf;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var left = track.scrollLeft;
          var best = 0, bestDist = Infinity;
          slides.forEach(function (s, i) { var d = Math.abs(s.offsetLeft - track.offsetLeft - left); if (d < bestDist) { bestDist = d; best = i; } });
          dotBtns.forEach(function (b, i) { b.classList.toggle('is-active', i === best); });
        });
      }, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mie-vote"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mie-vote')) {
    customElements.define('mie-vote', class extends HTMLElement {
      connectedCallback() {
        this.voteId = this.dataset.voteId;
        this.endsAt = Number(this.dataset.endsAt) || null;
        this.form = this.querySelector('[data-vote-form]');
        this.submit = this.querySelector('[data-vote-submit]');
        this.storageKey = 'mie_vote_' + this.voteId;

        if (this.isExpired()) return this.showExpired();

        const previous = this.readStored();
        if (previous) return this.showThanks(previous.label);

        this.preselectFromUrl();
        this.form.addEventListener('change', () => this.syncButton());
        this.form.addEventListener('submit', (event) => this.onSubmit(event));
        this.syncButton();
      }

      isExpired() {
        if (this.dataset.state === 'expired') return true;
        return this.endsAt !== null && Date.now() / 1000 > this.endsAt;
      }

      preselectFromUrl() {
        const wanted = new URLSearchParams(window.location.search).get('design');
        if (!wanted) return;
        const radio = Array.from(this.radios()).find((input) => input.value === wanted.toLowerCase());
        if (radio) {
          radio.checked = true;
          this.preselected = radio.value;
        }
      }

      radios() {
        return this.form.querySelectorAll('input[name="choice"]');
      }

      selected() {
        return this.form.querySelector('input[name="choice"]:checked');
      }

      syncButton() {
        this.submit.disabled = !this.selected();
      }

      onSubmit(event) {
        event.preventDefault();
        const choice = this.selected();
        if (!choice) return;

        // Re-check at click time: the page may have been open since before the deadline.
        if (this.isExpired()) return this.showExpired();

        if (window.posthog && typeof window.posthog.capture === 'function') {
          window.posthog.capture('vote_cast', {
            vote_id: this.voteId,
            choice: choice.value,
            choice_label: choice.dataset.label,
            preselected_choice: this.preselected || null,
            changed_from_preselected: Boolean(this.preselected) && this.preselected !== choice.value,
          });
        }

        this.writeStored({ choice: choice.value, label: choice.dataset.label });
        this.showThanks(choice.dataset.label);
      }

      showThanks(label) {
        this.form.hidden = true;
        const slot = this.querySelector('[data-vote-choice]');
        if (slot) slot.textContent = label;
        this.querySelector('[data-vote-thanks]').hidden = false;
      }

      showExpired() {
        this.form.hidden = true;
        this.querySelector('[data-vote-thanks]').hidden = true;
        this.querySelector('[data-vote-expired]').hidden = false;
      }

      readStored() {
        try {
          return JSON.parse(window.localStorage.getItem(this.storageKey));
        } catch (error) {
          return null;
        }
      }

      writeStored(value) {
        try {
          window.localStorage.setItem(this.storageKey, JSON.stringify(value));
        } catch (error) {
          // Storage unavailable (private mode etc.) — the vote is still sent.
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pdp]').forEach(function (pdp) {
    var cfg = {};
    var cfgEl = pdp.querySelector('[data-pdp-config]');
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) {}
    var i18n = cfg.i18n || {};
    var moneyFormat = cfg.moneyFormat || ('$' + String.fromCharCode(123, 123) + 'amount' + String.fromCharCode(125, 125));

    // Currency-aware money for COMPUTED sums (variant/bundle totals, savings).
    // Headline prices use the server-side `money`-filtered strings in [data-variant-money],
    // which Shopify already localizes to the active presentment currency.
    // Real multi-currency requires Shopify Markets + additional currencies (Shopify Payments).
    function money(cents) {
      if (window.Shopify && Shopify.currency && Shopify.currency.active) {
        var rate = parseFloat(Shopify.currency.rate || '1') || 1;
        try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: Shopify.currency.active }).format((cents / 100) * rate); } catch (e) {}
      }
      var v = (cents / 100).toFixed(2);
      if (moneyFormat.indexOf('amount_no_decimals') !== -1) v = Math.round(cents / 100).toString();
      return moneyFormat.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/g, v);
    }

    // Gallery
    var slides = pdp.querySelectorAll('[data-slide]');
    var thumbs = pdp.querySelectorAll('[data-thumb]');
    var idx = 0;
    function show(i) {
      if (!slides.length) return;
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === idx); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-thumb'), 10)); }); });
    var gp = pdp.querySelector('[data-g-prev]'); if (gp) gp.addEventListener('click', function () { show(idx - 1); });
    var gn = pdp.querySelector('[data-g-next]'); if (gn) gn.addEventListener('click', function () { show(idx + 1); });

    // Data
    var variants = [];
    try { variants = JSON.parse((pdp.querySelector('[data-variants]') || document.querySelector('[data-variants]')).textContent); } catch (e) {}
    var vmoney = {};
    try { vmoney = JSON.parse(pdp.querySelector('[data-variant-money]').textContent); } catch (e) {}
    // Per-variant, per-plan subscription prices (cents): { variantId: { planId: {price, compare} } }
    var planPrices = {};
    try { var ppEl = pdp.querySelector('[data-plan-prices]') || document.querySelector('[data-plan-prices]'); if (ppEl) planPrices = JSON.parse(ppEl.textContent); } catch (e) {}
    var currentPid = cfg.productId;

    var form = pdp.querySelector('.mie-pform');
    var idInput = pdp.querySelector('[data-variant-id]');
    var priceEl = pdp.querySelector('[data-price]');
    var compareEl = pdp.querySelector('[data-compare]');
    var saveEl = pdp.querySelector('[data-save]');
    var qtyInput = pdp.querySelector('[data-quantity]');
    var subTotal = pdp.querySelector('[data-sub-total]');
    var subCompare = pdp.querySelector('[data-sub-compare]');
    var subSaving = pdp.querySelector('[data-sub-saving]');
    var addBtn = pdp.querySelector('[data-add]');
    var addLabel = pdp.querySelector('[data-add-label]');

    // Purchase-mode selector (one-time / b2g1 / subscribe)
    var buyOpts = Array.prototype.slice.call(pdp.querySelectorAll('[data-buy-opt]'));
    var b2Tier = pdp.querySelector('[data-b2g1]');
    var planSelect = pdp.querySelector('[data-plan-select]');
    var planInput = pdp.querySelector('[data-selling-plan]');
    var subDesc = pdp.querySelector('[data-sub-desc]');
    var subFallback = cfg.subFallback || '';
    // Show the selected plan's own description in the subscribe label (falls back to the default).
    function updateSubDesc() {
      if (!subDesc || !planSelect) return;
      var opt = planSelect.options[planSelect.selectedIndex];
      var d = opt ? (opt.getAttribute('data-desc') || '') : '';
      subDesc.textContent = d || subFallback;
    }
    function buyMode() {
      var r = pdp.querySelector('[data-buy-radio]:checked');
      return r ? r.value : 'onetime';
    }

    function current() {
      if (!form) return variants[0];
      var selected = [];
      form.querySelectorAll('[data-option-input]').forEach(function (inp) { if (inp.checked) selected.push(inp.value); });
      if (!selected.length) return variants[0];
      return variants.filter(function (v) { return v.options.join('~~') === selected.join('~~'); })[0] || variants[0];
    }
    function qty() { return parseInt(qtyInput.value, 10) || 1; }

    // ---------- Bundle dropdowns (options are server-rendered in the DOM) ----------
    function closeAllDD() {
      pdp.querySelectorAll('[data-dd-list]').forEach(function (l) { l.hidden = true; });
      pdp.querySelectorAll('[data-dd-btn]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
    pdp.querySelectorAll('[data-dd]').forEach(function (dd) {
      var list = dd.querySelector('[data-dd-list]');
      var btn = dd.querySelector('[data-dd-btn]');
      var label = dd.querySelector('[data-dd-label]');
      if (!list || !btn) return;
      dd._selected = list.querySelector('[role="option"][aria-selected="true"]') || list.querySelector('[role="option"]');
      if (label && dd._selected) { label.textContent = dd._selected.getAttribute('data-title') || label.textContent; }
      btn.addEventListener('click', function () {
        var willOpen = list.hidden;
        closeAllDD();
        list.hidden = !willOpen;
        btn.setAttribute('aria-expanded', String(willOpen));
      });
      list.querySelectorAll('[role="option"]').forEach(function (op) {
        op.addEventListener('click', function () {
          dd._selected = op;
          if (label) label.textContent = op.getAttribute('data-title') || '';
          list.querySelectorAll('[role="option"]').forEach(function (o) { o.setAttribute('aria-selected', o === op ? 'true' : 'false'); });
          list.hidden = true;
          btn.setAttribute('aria-expanded', 'false');
          recompute();
        });
      });
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-dd]')) closeAllDD(); });

    function slotVariantId(slot) {
      var dd = slot.querySelector('[data-dd]');
      var li = dd && dd._selected;
      if (!li) return null;
      var vid = parseInt(li.getAttribute('data-variant-id'), 10);
      var pid = parseInt(li.getAttribute('data-pid'), 10);
      // Respect the on-page size selector when the current product is chosen.
      if (pid === currentPid && idInput) { return parseInt(idInput.value, 10) || vid; }
      return vid || null;
    }
    // Buy-2-Get-1 line items, assembled from the selected picker slots (unchanged logic).
    function b2Items() {
      var items = [];
      if (b2Tier) {
        b2Tier.querySelectorAll('[data-slot]').forEach(function (slot) {
          var vid = slotVariantId(slot);
          if (vid) items.push({ id: vid, quantity: 1 });
        });
      }
      if (!items.length && idInput) items = [{ id: parseInt(idInput.value, 10), quantity: qty() }];
      return items;
    }
    // Cart line items for the active purchase mode.
    function buildItems() {
      var m = buyMode();
      if (m === 'b2g1') return b2Items();
      var it = { id: parseInt(idInput.value, 10), quantity: qty() };
      if (m === 'subscribe' && planInput && planInput.value) {
        it.selling_plan = parseInt(planInput.value, 10) || planInput.value;
      }
      return [it];
    }

    function recompute() {
      var subtotal = 0, compare = 0;
      if (buyMode() === 'b2g1' && b2Tier) {
        // Sum the selected B2G1 slots — free slot(s) contribute 0.
        b2Tier.querySelectorAll('[data-slot]').forEach(function (slot) {
          var dd = slot.querySelector('[data-dd]');
          var li = dd && dd._selected;
          if (!li) return;
          var price = parseInt(li.getAttribute('data-price'), 10) || 0;
          var comp = parseInt(li.getAttribute('data-compare'), 10) || 0;
          var isFree = slot.getAttribute('data-free') === 'true';
          subtotal += isFree ? 0 : price;
          compare += (comp > price ? comp : price);
        });
      } else if (buyMode() === 'subscribe') {
        // Subscribe: use the selected plan's real allocation price for this variant
        // (discounted price + full price to strike through). Falls back to base price.
        var vs = current();
        var qs = qty();
        var planId = planSelect ? planSelect.value : (planInput ? planInput.value : '');
        var alloc = vs && planPrices[vs.id] ? planPrices[vs.id][planId] : null;
        if (alloc) {
          subtotal = alloc.price * qs;
          compare = (alloc.compare > alloc.price ? alloc.compare : alloc.price) * qs;
        } else {
          var baseS = vs ? vs.price : 0;
          subtotal = baseS * qs;
          compare = (vs && vs.compare_at_price > vs.price) ? vs.compare_at_price * qs : baseS * qs;
        }
      } else {
        // One-time: selected variant × quantity.
        var v = current();
        var q = qty();
        var base = v ? v.price : 0;
        subtotal = base * q;
        compare = (v && v.compare_at_price > v.price) ? v.compare_at_price * q : base * q;
      }
      if (subTotal) subTotal.textContent = money(subtotal);
      if (subCompare) subCompare.textContent = (compare > subtotal) ? money(compare) : '';
      if (subSaving) {
        var save = compare - subtotal;
        if (save > 0) { subSaving.textContent = (i18n.saving || '') + ' ' + money(save); subSaving.hidden = false; }
        else { subSaving.hidden = true; }
      }
    }

    function render() {
      var v = current();
      if (!v) return;
      idInput.value = v.id;
      var vm = vmoney[v.id];
      if (vm) {
        priceEl.textContent = vm.price;
        if (compareEl) { if (vm.hasCompare) { compareEl.textContent = vm.compare; compareEl.style.display = ''; } else { compareEl.style.display = 'none'; } }
      } else {
        priceEl.textContent = money(v.price);
        if (compareEl) { if (v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price); compareEl.style.display = ''; } else { compareEl.style.display = 'none'; } }
      }
      if (saveEl) { if (v.compare_at_price > v.price) { saveEl.textContent = (i18n.save || 'Save') + ' ' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%'; saveEl.style.display = ''; } else { saveEl.style.display = 'none'; } }
      if (addBtn) {
        addBtn.disabled = !v.available;
        // Never blank the label — fall back to the server-rendered text if i18n is empty.
        var lbl = v.available ? i18n.add : i18n.soldOut;
        if (lbl) { addLabel.textContent = lbl; }
      }
      form.querySelectorAll('.mie-pform__swatch').forEach(function (sw) { var inp = sw.querySelector('input'); sw.classList.toggle('is-active', inp.checked); });

      recompute();
    }

    // Expand only the active option's panel; set the selling plan only in subscribe mode.
    function syncBuy() {
      buyOpts.forEach(function (opt) {
        var radio = opt.querySelector('[data-buy-radio]');
        var on = radio && radio.checked;
        opt.classList.toggle('is-active', on);
        var panel = opt.querySelector('[data-buy-panel]');
        if (panel) panel.hidden = !on;
      });
      if (planInput) {
        planInput.value = (buyMode() === 'subscribe' && planSelect) ? (planSelect.value || '') : '';
      }
      // Express (Shop Pay/Apple Pay) checkout only supports the plain one-time add; hide it
      // for subscribe (can't carry the plan) and b2g1 (can't carry the extra line items).
      var expressEl = pdp.querySelector('[data-express]');
      if (expressEl) { expressEl.hidden = (buyMode() !== 'onetime'); }
      recompute();
    }

    if (form) {
      form.querySelectorAll('[data-option-input]').forEach(function (inp) { inp.addEventListener('change', render); });
      form.querySelectorAll('[data-buy-radio]').forEach(function (r) { r.addEventListener('change', syncBuy); });
      if (planSelect) { planSelect.addEventListener('change', function () { if (buyMode() === 'subscribe' && planInput) planInput.value = planSelect.value; updateSubDesc(); recompute(); }); }
      // Quantity stepper — drives the same hidden name="quantity" the cart reads.
      var qtyDec = pdp.querySelector('[data-qty-dec]');
      var qtyInc = pdp.querySelector('[data-qty-inc]');
      function setQty(n) { n = Math.max(1, parseInt(n, 10) || 1); if (qtyInput) qtyInput.value = n; render(); }
      if (qtyDec) qtyDec.addEventListener('click', function () { setQty(qty() - 1); });
      if (qtyInc) qtyInc.addEventListener('click', function () { setQty(qty() + 1); });
      if (qtyInput) qtyInput.addEventListener('change', function () { setQty(qty()); });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var items;
        try { items = buildItems(); }
        catch (err) { items = [{ id: parseInt(idInput.value, 10), quantity: qty() }]; }
        items = (items || []).filter(function (it) { return it && it.id; });
        if (!items.length) return;
        var addBtnEl = form.querySelector('[data-add]');
        if (addBtnEl) { addBtnEl.setAttribute('aria-busy', 'true'); }
        function done() { if (addBtnEl) { addBtnEl.removeAttribute('aria-busy'); } }
        var addUrl = (cfg.addUrl || '/cart/add');
        if (window.mieCartAddItems) {
          // Route through the drawer's proven add path (same one the collection
          // "Add to basket" uses) — adds the items and opens the sidebar.
          Promise.resolve(window.mieCartAddItems(items)).then(done, done);
        } else {
          fetch(addUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
            .then(function (r) { return r.json(); })
            .then(function () {
              document.dispatchEvent(new CustomEvent('mie:cart:open'));
              if (window.mieCartOpen) { try { window.mieCartOpen(); } catch (err) {} }
            })
            .catch(function () {})
            .then(done);
        }
      });
    }

    syncBuy();
    updateSubDesc();
    render();

    // Sticky bar reveal after hero add-to-cart scrolls out
    var bar = document.querySelector('[data-stickybar]');
    var addWrap = pdp.querySelector('.mie-pform__add');
    if (bar && addWrap && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { bar.hidden = en.isIntersecting; });
      }, { rootMargin: '-120px 0px 0px 0px' }).observe(addWrap);
    }
  });

  // ---------- "See it in action" shoppable video modal ----------
  (function () {
    var dataEl = document.querySelector('[data-inaction]');
    var modal = document.querySelector('[data-ia-modal]');
    if (!dataEl || !modal) return;
    var videos = [];
    try { videos = JSON.parse(dataEl.textContent); } catch (e) {}
    videos = (videos || []).filter(function (v) { return v && v.src; });
    if (!videos.length) return;

    var videoEl = modal.querySelector('[data-ia-video]');
    var featuredWrap = modal.querySelector('[data-ia-featured]');
    var relatedWrap = modal.querySelector('[data-ia-related]');
    var relatedHead = modal.querySelector('[data-ia-related-head]');
    var mcard = modal.querySelector('[data-ia-mcard]');
    var progress = modal.querySelector('[data-ia-progress]');
    var progressBar = modal.querySelector('[data-ia-progress-bar]');
    var playBtn = modal.querySelector('[data-ia-playtoggle]');
    var muteBtn = modal.querySelector('[data-ia-mute]');
    var muteOn = modal.querySelector('[data-ia-mute-on]');
    var muteOff = modal.querySelector('[data-ia-mute-off]');
    var addLabel = modal.getAttribute('data-ia-add-label') || 'Add to cart';
    var soldLabel = modal.getAttribute('data-ia-sold-label') || 'Sold out';
    var current = 0, mIndex = 0, lastFocus = null;

    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

    function productRow(p) {
      var media = p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '';
      var btn = p.available
        ? '<button type="button" class="mie-ia-addbtn" data-ia-add="' + p.id + '">' + esc(addLabel) + '</button>'
        : '<button type="button" class="mie-ia-addbtn" disabled>' + esc(soldLabel) + '</button>';
      return '<div class="mie-ia-prod" data-ia-prod>'
        + '<a class="mie-ia-prod__media" href="' + esc(p.url) + '">' + media + '</a>'
        + '<div class="mie-ia-prod__body">'
        + '<a class="mie-ia-prod__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>'
        + '<div class="mie-ia-prod__buy">'
        + '<div class="mie-ia-qty"><button type="button" data-ia-qdec aria-label="-">&minus;</button><input type="number" data-ia-qty value="1" min="1"><button type="button" data-ia-qinc aria-label="+">+</button></div>'
        + btn + '</div></div></div>';
    }

    function renderPanels() {
      var v = videos[current];
      featuredWrap.innerHTML = (v.featured || []).map(productRow).join('');
      var rel = v.related || [];
      relatedWrap.innerHTML = rel.map(productRow).join('');
      relatedHead.hidden = rel.length === 0;
      mIndex = 0;
      renderMcard();
    }

    function mcardList() { var v = videos[current]; return (v.featured || []).concat(v.related || []); }
    function renderMcard() {
      var list = mcardList();
      if (!list.length) { mcard.innerHTML = ''; return; }
      mIndex = ((mIndex % list.length) + list.length) % list.length;
      var p = list[mIndex];
      var media = p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '';
      var btn = p.available
        ? '<button type="button" class="mie-ia-addbtn" data-ia-add="' + p.id + '">' + esc(addLabel) + '</button>'
        : '<button type="button" class="mie-ia-addbtn" disabled>' + esc(soldLabel) + '</button>';
      var arrows = list.length > 1
        ? '<button type="button" class="mie-ia-mcard__prev" data-ia-mprev aria-label="Previous">&lsaquo;</button><button type="button" class="mie-ia-mcard__next" data-ia-mnext aria-label="Next">&rsaquo;</button>'
        : '';
      mcard.innerHTML = '<div class="mie-ia-mcard__inner" data-ia-prod>'
        + '<a class="mie-ia-mcard__media" href="' + esc(p.url) + '">' + media + '</a>'
        + '<div class="mie-ia-mcard__body"><a class="mie-ia-mcard__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' + btn + '</div>'
        + arrows + '</div>';
    }

    function updatePlayIcon() { if (playBtn) playBtn.hidden = !videoEl.paused; }
    function updateMuteIcon() {
      // Toggle via style.display — inline <svg> doesn't reliably honour the `hidden` attribute.
      if (muteOn) muteOn.style.display = videoEl.muted ? 'none' : '';
      if (muteOff) muteOff.style.display = videoEl.muted ? '' : 'none';
    }

    function loadVideo(i) {
      current = ((i % videos.length) + videos.length) % videos.length;
      var v = videos[current];
      videoEl.src = v.src;
      if (v.poster) videoEl.poster = v.poster;
      try { videoEl.currentTime = 0; } catch (e) {}
      if (progressBar) progressBar.style.width = '0%';
      var pr = videoEl.play();
      if (pr && pr.catch) pr.catch(function () {});
      renderPanels();
      updatePlayIcon();
      updateMuteIcon();
    }

    function open(i) {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      loadVideo(i || 0);
    }
    function close() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      try { videoEl.pause(); } catch (e) {}
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    }

    function togglePlay() { if (videoEl.paused) { var pr = videoEl.play(); if (pr && pr.catch) pr.catch(function () {}); } else { videoEl.pause(); } updatePlayIcon(); }

    // Triggers (thumbnails)
    document.querySelectorAll('[data-ia-open]').forEach(function (b) {
      b.addEventListener('click', function () { open(parseInt(b.getAttribute('data-ia-open'), 10) || 0); });
    });
    // In-column reel arrows (scroll)
    document.querySelectorAll('[data-ia-scroll]').forEach(function (b) {
      b.addEventListener('click', function () {
        var track = b.parentElement.querySelector('[data-ia-track]');
        if (track) track.scrollBy({ left: (parseInt(b.getAttribute('data-ia-scroll'), 10) || 1) * track.clientWidth * 0.8, behavior: 'smooth' });
      });
    });

    modal.querySelectorAll('[data-ia-close]').forEach(function (b) { b.addEventListener('click', close); });
    var prevB = modal.querySelector('[data-ia-prev]'); if (prevB) prevB.addEventListener('click', function () { loadVideo(current - 1); });
    var nextB = modal.querySelector('[data-ia-next]'); if (nextB) nextB.addEventListener('click', function () { loadVideo(current + 1); });
    if (playBtn) playBtn.addEventListener('click', togglePlay);
    videoEl.addEventListener('click', togglePlay);
    videoEl.addEventListener('play', updatePlayIcon);
    videoEl.addEventListener('pause', updatePlayIcon);
    videoEl.addEventListener('ended', function () { loadVideo(current + 1); });
    videoEl.addEventListener('timeupdate', function () { if (progressBar && videoEl.duration) progressBar.style.width = (videoEl.currentTime / videoEl.duration * 100) + '%'; });
    videoEl.muted = true;
    if (muteBtn) muteBtn.addEventListener('click', function () { videoEl.muted = !videoEl.muted; updateMuteIcon(); });
    if (progress) progress.addEventListener('click', function (e) { if (!videoEl.duration) return; var r = progress.getBoundingClientRect(); videoEl.currentTime = ((e.clientX - r.left) / r.width) * videoEl.duration; });

    // Delegated actions inside the modal (add / qty / mobile paging)
    modal.addEventListener('click', function (e) {
      var add = e.target.closest('[data-ia-add]');
      if (add && !add.disabled) {
        var vid = parseInt(add.getAttribute('data-ia-add'), 10);
        var q = 1;
        var prod = add.closest('[data-ia-prod]');
        var qEl = prod && prod.querySelector('[data-ia-qty]');
        if (qEl) q = Math.max(1, parseInt(qEl.value, 10) || 1);
        if (vid && window.mieCartAdd) { window.mieCartAdd(vid, q); }
        return;
      }
      var dec = e.target.closest('[data-ia-qdec]');
      if (dec) { var i1 = dec.closest('[data-ia-prod]').querySelector('[data-ia-qty]'); i1.value = Math.max(1, (parseInt(i1.value, 10) || 1) - 1); return; }
      var inc = e.target.closest('[data-ia-qinc]');
      if (inc) { var i2 = inc.closest('[data-ia-prod]').querySelector('[data-ia-qty]'); i2.value = Math.max(1, (parseInt(i2.value, 10) || 1) + 1); return; }
      if (e.target.closest('[data-ia-mprev]')) { mIndex -= 1; renderMcard(); return; }
      if (e.target.closest('[data-ia-mnext]')) { mIndex += 1; renderMcard(); return; }
    });

    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowUp') loadVideo(current - 1);
      else if (e.key === 'ArrowDown') loadVideo(current + 1);
    });

    // Basic vertical swipe on mobile to move between videos
    var touchY = null;
    var stage = modal.querySelector('.mie-ia-stage');
    if (stage) {
      stage.addEventListener('touchstart', function (e) { touchY = e.changedTouches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (touchY == null) return;
        var dy = e.changedTouches[0].clientY - touchY;
        if (Math.abs(dy) > 60) { loadVideo(dy < 0 ? current + 1 : current - 1); }
        touchY = null;
      }, { passive: true });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
